import { ReactNode, useEffect } from "react";
import Navbar from "@/components/layout/Header";
import GlobalDrawer from "@/components/layout/GlobalDrawer";
import Footer from "@/components/layout/Footer";
import { useLocale } from "next-intl";
import { YandexMapsScript } from "@/components/layout/YMapsScript";
import { AnnouncementRenderer } from "@/components/layout/AnnouncementsRenderer";
import HelpWidget from "@/components/layout/HelpWidget";
import { GoogleTagManagerScript } from "@/components/layout/GoogleTagManagerScript";
import { YandexMetrikaScript } from "@/components/layout/YandexMetrikaScript";
import TikTokPixelScript from "@/components/layout/TikTokPixelScript";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useAuth } from "@/components/auth/AuthProvider";
import { usePathname, useSearchParams } from "next/navigation";

export default function AppLayout({ headerBanner, children }: { headerBanner: ReactNode, children: ReactNode }) {
  const locale = useLocale();
  let langParam = "ru_RU";
  if (locale === "en") langParam = "en_US";
  if (locale === "kz") langParam = "kk_KK";

  const { track } = useAnalytics();
  const { userId, isAuthenticated } = useAuth();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isAuthenticated === undefined) return;
    if (isAuthenticated && !userId) return;
  
    track({
      type: 'session_start',
      data: { userId: isAuthenticated && userId ? userId : null }
    });
  
  }, [pathname, isAuthenticated, userId, track]);

  useEffect(() => {
    const params = searchParams.toString();
    const url = window.location.origin + pathname + (params ? `?${params}` : '');
    
    track({
      type: 'page_view',
      data: { url }
    })
  }, [pathname, searchParams, track]);
  
  return (
    <>
      <Navbar />
      { headerBanner }
      <GlobalDrawer />
      <main>{children}</main>
      <HelpWidget />
      <YandexMapsScript lang={langParam} />
      <GoogleTagManagerScript />
      <YandexMetrikaScript />
      <TikTokPixelScript />
      <AnnouncementRenderer />
      <Footer />
    </>
  );
}